module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.config.imgUrl,
      "alt": "cover"
    }
  }), _vm._v(" "), _vm._l((_vm.data.data), function(zone, index) {
    return _c('div', {
      key: index,
      staticClass: "zone",
      style: ({
        width: _vm.getZoneStyle(zone.widthPer),
        height: _vm.getZoneStyle(zone.heightPer),
        top: _vm.getZoneStyle(zone.topPer),
        left: _vm.getZoneStyle(zone.leftPer)
      }),
      on: {
        "click": function($event) {
          return _vm.handleZoneClick(zone)
        }
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-40bd19b2","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/imgHotZone.vue
// module id = 793
// module chunks = 0 1 3